import { render, staticRenderFns } from "./productRecord.vue?vue&type=template&id=1aab490c&scoped=true&"
import script from "./productRecord.vue?vue&type=script&lang=js&"
export * from "./productRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aab490c",
  null
  
)

export default component.exports